module.exports = __webpack_public_path__ + "static/fleet-33-seat-coach-sm-1f95747f37cdd5d17c7fe24d1bdd699d.jpg";